export default __webpack_public_path__ + "static/media/bg1.35153d5c.png";